import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmployerUserModalComponent } from './employer-user-modal.component';
import { FormGroupModule } from '../form-group/form-group.module';
import { PipesModule } from '@app/pipes/pipes.module';
import { ReactiveFormsModule } from '@angular/forms';
import { HasAccessInterviewDirective } from './directives/HasAccessInterview.directive';

@NgModule({
  imports: [
    CommonModule,
    FormGroupModule,
    PipesModule,
    ReactiveFormsModule
  ],
  declarations: [
    HasAccessInterviewDirective,
    EmployerUserModalComponent
  ],
  exports: [
    EmployerUserModalComponent,
    HasAccessInterviewDirective
  ] 
})
export class EmployerUserModalModule { }
